import React from "react";

import { InheritanceStatus } from "@swivl-mono/types";
import { Dropdown, Input, RadioButtons } from "@swivl-mono/ui";
import "./WorkflowsNavSearch.scss";

import { useOutsideClick } from "@swivl-mono/ui";
export interface WorkflowsNavSearchInterface {
  searchQuery: string;
  searchType: "quest" | "node"
  inheritanceFilter: InheritanceStatus | "ALL"
  isSearching?: boolean
}

interface WorkflowsNavSearchProps {
  isChild: boolean;
  searchUpdated: (searchData: WorkflowsNavSearchInterface) => void;
  data: WorkflowsNavSearchInterface
  isLoading?: boolean
}

export function WorkflowsNavSearch(props: WorkflowsNavSearchProps) {
  const { data, isChild, searchUpdated, isLoading } = props;
  const [isEditing, setIsEditing] = React.useState(false);
  const ref = useOutsideClick(() => {
    setIsEditing(false);
  });

  const shouldBeOpen = data.searchQuery.length > 0 || isEditing || data.inheritanceFilter !== "ALL";

  return (
    <div
      ref={ref}
      className={`WorkflowsNavSearch ${shouldBeOpen && "isEditing"}`}>
      <div className="inner">
        <Input
          isSearch={true}
          onFocus={() => { setIsEditing(true) }}
          onChange={(e) => { searchUpdated({ ...data, searchQuery: e.target.value }) }}
          value={data.searchQuery}
          onReturnPressed={() => { setIsEditing(false) }}
          placeholder={data.searchType === "quest" ? "Search Quests..." : "Search Nodes..."}
          isRound={true}
          // debounce={data.searchType === "node" ? 500 : 0}
          isSearching={isLoading}
        />
        <div className="WorkflowsNavSearch__options" >
          <div className="radioButtonGroup">
            <RadioButtons inline={true} value={data.searchType} options={[
              { label: "Quests", value: "quest" },
              { label: "Nodes", value: "node" },
            ]} onOptionSelected={(option) => {
              searchUpdated({ ...data, searchType: option.value })
            }
            } />

            {isChild && (
              <Dropdown
                value={data.inheritanceFilter}
                options={[
                  { label: "ALL", value: "ALL" },

                  { label: "STANDALONE", value: InheritanceStatus.NONE },
                  { label: "CHILD", value: InheritanceStatus.IS_CHILD },
                  { label: "PARENT", value: InheritanceStatus.IS_PARENT },
                ]} optionSelected={(option) => {
                  searchUpdated({ ...data, inheritanceFilter: option.value })
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );

}